import React from 'react';

import CircleIcon from '@mui/icons-material/Circle';
import { useGridApiContext } from '@mui/x-data-grid';
import { FormControl, MenuItem, Select } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import { getProjectStatusOptions } from 'common/utils/helpers';

const CustomStatusEditField = (props) => {
    const { id, field, value } = props;
    const apiRef = useGridApiContext();

    const handleChange = (event) => {
        apiRef.current.setEditCellValue({
            id,
            field,
            value: event.target.value,
        });
    };
    const options = getProjectStatusOptions();
    return (
        <FormControl fullWidth>
            <Select
                labelId="status-select-label"
                id="status-select"
                value={value}
                onChange={handleChange}
                variant="standard"
                sx={{
                    '& .MuiSelect-select': {
                        alignItems: 'center',
                        display: 'flex',
                        gap: 1,
                    },
                }}
            >
                {options.map(({ label, primary_color, value }) => (
                    <MenuItem
                        key={`option-${value}`}
                        value={value}
                        sx={{ alignItems: 'center', display: 'flex', gap: 1 }}
                    >
                        <CircleIcon
                            sx={{ color: primary_color, fontSize: 20 }}
                        />{' '}
                        {label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

CustomStatusEditField.propTypes = {
    field: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.number,
};

export default CustomStatusEditField;
